<template>
  <label class="switch" :class="{ active: selected, disabled: disable }">
    <span @click="click" class="slider round"></span>
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    disable: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => {
    return {
      selected: false,
    };
  },
  watch: {
    value() {
      this.selected = this.value;
    },
  },
  mounted() {
    this.selected = this.value;
  },
  methods: {
    click() {
      if (this.disable) return;
      this.selected = !this.selected;
      this.$emit("input", this.selected);
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  min-width: 26px;
  min-height: 14px;
}

.switch.disabled {
  pointer-events: none;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #999;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}

.switch.active .slider {
  background-color: var(--u-green01) !important;
}

.switch.disabled .slider {
  background-color: #d6d6d6 !important;
}

.switch.active.disabled .slider {
  background-color: #ceefeb !important;
}

.switch.active .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
